import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { RegistrationService } from '../registration.service';
import { EditRegistrationModalComponent } from 'src/app/shared/modals/edit-registration/edit-registration-modal.component';
import { Registration } from '../registration';
import { SessionService } from 'src/app/shared/services/session.service';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { OutingIteration } from 'src/app/outing/outing-iteration';
import { BaseComponent } from 'src/app/core/base.component';
import { SignalrService } from 'src/app/shared/services/signalr.service';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarNotificationComponent } from 'src/app/shared/ui/snackbar-notification/snackbar-notification/snackbar-notification.component';
import { QueryFilter } from 'src/app/shared/models/query-filter.model';
import { StripeRegistrationPaymentModalComponent } from 'src/app/shared/modals/stripe-registration-payment-modal/stripe-registration-payment-modal.component';
import { PaymentType } from 'src/app/shared/models/payment-type-enum';
import { StripeRefundModalComponent } from 'src/app/shared/modals/stripe-refund-modal/stripe-refund-modal.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'registrations-list',
    templateUrl: './registrations-list.component.html',
    styleUrls: ['./registrations-list.component.scss'],
    standalone: false
})
export class RegistrationsListComponent extends BaseComponent implements OnInit {
  @Input() filter: QueryFilter = new QueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public registrations: Registration[] = [];
  public selectedIteration: OutingIteration = new OutingIteration();
  public displayedColumns: string[] = [
    'firstName', 'lastName', 'startingHole', 'teamCaptain',
    'hasPaid', 'isCheckedIn', 'skins', 'actions'
  ]
  public hubMessage: string;
  public paymentType = PaymentType;

  constructor(private registrationService: RegistrationService,
    public dialog: MatDialog,
    public sessionService: SessionService,
    private signalrService: SignalrService,
    private snackBarRef: MatSnackBar,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
    this.filter.pageSize = 15;
    this.filter.sortColumn = 'lastName';
  }

  ngOnInit(): void {
    if (this.isGlobalOutingSet()) {
      this.selectedIteration = this.getGlobalOutingIteration();
      this.signalrService.startConnection(environment.signalR.registrationHubUrl, this.sessionService.getUser().auth0Id);
      this.waitForConnectionAndSetupListener();
      this.getRegistrations();
    }
  }

  waitForConnectionAndSetupListener() {
    const checkConnection = () => {
      if (this.signalrService.isConnected()) {
        this.registrationUpdateListener();
      } else {
        setTimeout(checkConnection, 100);
      }
    };
    
    setTimeout(checkConnection, 100);
  }

  registrationUpdateListener() {
    this.signalrService.getListnerConnection(environment.signalR.registrationUpdateListener).subscribe(result => {
      this.snackBarRef.openFromComponent(SnackbarNotificationComponent, {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 5000,
        data: {text: `Registration for "${result.firstName} ${result.lastName}" has been updated`, useInnerHtml: true}
      });
      this.getRegistrations();
    });
  }

  registrationPaymentListener() {
    this.signalrService.getListnerConnection(environment.signalR.registrationPaymentListener).subscribe(result => {
      this.snackBarRef.openFromComponent(SnackbarNotificationComponent, {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 5000,
        data: {text: `"${result.firstName} ${result.lastName}" has paid`, useInnerHtml: true}
      });
      this.getRegistrations();
    });
  }

  getRegistrations() {
    this.isLoading = true;
    this.registrationService.getAllByIteration(this.selectedIteration.id, this.filter).subscribe((result: any) => {
      this.registrations = result.results;
      this.filter.totalCount = result.totalCount;
      this.updateFilterEvent.emit(result.results);
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
      //throw error
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getRegistrations();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 15;
  }

  hasRefundGiven(registration: Registration): boolean {
    const amount = registration?.refundAmount;
    return amount != null && amount > 0 && !registration.hasPaid;
  }

  edit(registration: Registration) {
    const dialogRef = this.dialog.open(EditRegistrationModalComponent,{
      width: '40vw'
    });

    dialogRef.componentInstance.registration = registration;

    // dialogRef.componentInstance.registration.id = registration.id;
    // dialogRef.componentInstance.registration.outingIterationId = this.selectedIteration.id;
    // dialogRef.componentInstance.registration.userId = registration.userId;
    // dialogRef.componentInstance.registration.firstName = registration.firstName;
    // dialogRef.componentInstance.registration.lastName = registration.lastName;
    // dialogRef.componentInstance.registration.startingHole = registration.startingHole;
    // dialogRef.componentInstance.registration.isCheckedIn = registration.isCheckedIn;
    // dialogRef.componentInstance.registration.hasPaid = registration.hasPaid;
    // dialogRef.componentInstance.registration.startDate = registration.startDate;
    // dialogRef.componentInstance.registration.lastEditedBy = this.sessionService.getUserId();
    // dialogRef.componentInstance.registration.teamCaptain = registration.teamCaptain;
    // dialogRef.componentInstance.registration.playerRegistrationCode = registration.playerRegistrationCode;
    // dialogRef.componentInstance.registration.skins = registration.skins;
    // dialogRef.componentInstance.registration.paymentType = registration.paymentType == null ? null : registration.paymentType;
    dialogRef.componentInstance.submitText = 'Save';
    dialogRef.afterClosed().subscribe((response) => {
      if (response == 'Save') {
        this.getRegistrations();
      }
    });
  }

  checkIn(registration: Registration) {
    this.isLoading = true;
    registration.isCheckedIn = true;
    registration.outingIterationId = this.selectedIteration.id;
    registration.lastEditedBy = this.sessionService.getUserId();
    this.registrationService.update(registration.id, registration).subscribe(() => {
      this.getRegistrations();
      this.isLoading = false;
    }, err => {
      registration.isCheckedIn = false;
      this.isLoading = false;
    });
  }

  updateSkins(registration: Registration) {
    this.isLoading = true;
    registration.skins = true;
    registration.outingIterationId = this.selectedIteration.id;
    registration.lastEditedBy = this.sessionService.getUserId();
    this.registrationService.update(registration.id, registration).subscribe(() => {
      this.getRegistrations();
      this.isLoading = false;
    }, err => {
      registration.isCheckedIn = false;
      this.isLoading = false;
    });
  }

  delete(registration: Registration) {
    const dialogRef = this.dialog.open(AlertModalComponent, {
      width: '40vw'
    });
    dialogRef.componentInstance.title = 'Delete Registration';
    dialogRef.componentInstance.body = `Are you sure you want to remove user registration for "<strong>${registration.firstName}
    ${registration.lastName}</strong>"? <br /><br />Once you delete the registration it cannot be undone.`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      this.isLoading = true;
      if (response === 'Yes') {
        let dto = { id: registration.id, userId: registration.userId, lastEditedBy: this.sessionService.getUserId() };
        this.registrationService.delete(registration.id, dto).subscribe(() => {
          this.getRegistrations();
          this.isLoading = false;
        }, err => {
          this.isLoading = false;
        });
      }
      this.isLoading = false;
    });
  }

  pay(registration: Registration) {
    const dialogRef = this.dialog.open(StripeRegistrationPaymentModalComponent, {
      width: '40vw',
      disableClose: true
    });

    dialogRef.componentInstance.signalrService = this.signalrService;
    dialogRef.componentInstance.registration = registration;

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result !== 'cancel') {
        this.snackBarRef.openFromComponent(SnackbarNotificationComponent, {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 15000,
          data: {text: `Payment Successful for "${result.firstName} ${result.lastName}"`, useInnerHtml: true}
        });
        this.getRegistrations();
      }
    });
  }

  refund(registration: Registration) {
    const dialogRef = this.dialog.open(StripeRefundModalComponent,{
      width: '40vw',
      disableClose: true
    });

    if (registration.paymentType === PaymentType.CashCheck) {
      dialogRef.componentInstance.title = 'Cash Refund';
    } else {
      dialogRef.componentInstance.title = 'Credit/Debit Refund';
    }

    dialogRef.componentInstance.body = `Are you sure you want to issue a refund for "${registration.firstName} 
    ${registration.lastName}"? Once refund is issued, GolfTech Management, LLC will no longer be the responsible 
    party for the money that was issued during the original transaction.`;

    dialogRef.componentInstance.paymentType = registration.paymentType;
    dialogRef.componentInstance.registration = registration;
    
    dialogRef.afterClosed().subscribe((response) => {
      if (response.status === 'success') {
        registration.paymentType = null;
        registration.hasPaid = false;
        registration.isCheckedIn = false;
        this.registrationService.update(registration.id, registration).subscribe({
          next: (result) => {
            this.getRegistrations();
          },
          error: (err) => {
            console.log(err)
          }
        });
      }
    });
  }

  canEditOrDelete(registrationDate: Date): boolean {
    return new Date().setDate(new Date().getDate()) <= new Date(registrationDate).setDate(new Date(registrationDate).getDate() + 1);
  }
}
